import _ from 'underscore';
import { format, getYear, isBefore, isSameDay, parseISO } from 'date-fns';
import ruLocale from 'date-fns/locale/ru';

export const parsePrice = (price) => {
	const result = {};

	if (!price.min) {
		if (!price.max) {
			result.text = 'Бесплатно';
			result.isFree = true;
		} else {
			result.text = `до\u00A0${price.max}\u00A0руб.`;
		}
	} else {
		result.text = `от\u00A0${price.min}\u00A0руб.`;
	}

	return result;
};

export const getDateRange = (event) => {
	const startDate = parseISO(event.startDate);
	const endDate = parseISO(event.endDate);
	const endDateFormat = 'd MMMM yyyy';
	let startDateFormat = 'd MMMM yyyy';

	if (getYear(startDate) === getYear(endDate)) {
		startDateFormat = 'd MMMM';
	}

	let dateRange = `С\u00A0${format(startDate, startDateFormat, {
		locale: ruLocale
	})} по ${format(endDate, endDateFormat, { locale: ruLocale })}`;

	if (isSameDay(startDate, endDate)) {
		dateRange = format(endDate, endDateFormat, { locale: ruLocale });
	}

	return dateRange;
};

export const getEventNearestSeancePlace = (event, options) => {
	let seances = _(event.seances).sortBy('startDate');

	if (options && (options.localeId || options.localeName)) {
		const placeIndexes = _(event.places).reduce((acc, place, index) => {
			if (
				place.locale._id === options.localeId ||
				place.locale.sysName === options.localeName
			) {
				acc.push(index);
			}
			return acc;
		}, []);

		seances = _(seances).filter((seance) =>
			_(placeIndexes).contains(seance.placeIndex)
		);
	}

	let place = null;

	if (seances.length) {
		const now = new Date();

		let nearestSeance = _(seances).find(
			(seance) =>
				isSameDay(now, parseISO(seance.startDate)) ||
				isBefore(now, parseISO(seance.startDate))
		);

		if (!nearestSeance) {
			nearestSeance = _(seances).last();
		}

		place = event.places[nearestSeance.placeIndex];
	}

	return place;
};

export const checkPastSeance = (seances) => {
	const now = new Date();

	return seances.some((seance) => isBefore(now, parseISO(seance.endDate)));
};
